"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserIdentityModel = exports.IdentityProofDocumentModel = void 0;
const validator_1 = require("@leavy/validator");
const Address_1 = require("../../common/model/Address");
class IdentityProofDocumentModel {
}
__decorate([
    (0, validator_1.IsUUID)("4"),
    __metadata("design:type", String)
], IdentityProofDocumentModel.prototype, "fileId", void 0);
exports.IdentityProofDocumentModel = IdentityProofDocumentModel;
/**
 * User's identity
 */
class UserIdentityModel {
}
__decorate([
    (0, validator_1.IsString)(),
    (0, validator_1.IsNotEmpty)(),
    __metadata("design:type", String)
], UserIdentityModel.prototype, "firstName", void 0);
__decorate([
    (0, validator_1.IsString)(),
    (0, validator_1.IsNotEmpty)(),
    __metadata("design:type", String)
], UserIdentityModel.prototype, "lastName", void 0);
__decorate([
    (0, validator_1.Type)(() => Address_1.AddressModel),
    (0, validator_1.IsDefined)(),
    (0, validator_1.ValidateNested)(),
    __metadata("design:type", Address_1.AddressModel)
], UserIdentityModel.prototype, "address", void 0);
__decorate([
    (0, validator_1.IsDateString)(),
    __metadata("design:type", String)
], UserIdentityModel.prototype, "birthDate", void 0);
__decorate([
    (0, validator_1.IsString)(),
    (0, validator_1.IsNotEmpty)(),
    __metadata("design:type", String)
], UserIdentityModel.prototype, "cityOfBirth", void 0);
__decorate([
    (0, validator_1.IsISO31661Alpha2)(),
    __metadata("design:type", String)
], UserIdentityModel.prototype, "countryOfBirth", void 0);
__decorate([
    (0, validator_1.IsString)(),
    (0, validator_1.IsNotEmpty)(),
    __metadata("design:type", String)
], UserIdentityModel.prototype, "nationality", void 0);
exports.UserIdentityModel = UserIdentityModel;
//# sourceMappingURL=UserIdentityModel.js.map